// Workspace catalog — DR-12 / §14. Eight fixed top-level destinations: 7
// platform + 1 operational. These are the navigation definitions; the actual
// MFE remotes are registered from workspaces.json (see Workspaces/loadRemote.ts).

export type WorkspaceKind = 'platform' | 'operational';

export interface WorkspaceNavItem {
  /** Matches the remote id in workspaces.json. */
  id: string;
  label: string;
  route: string;
  /** lucide-react icon name. */
  icon: string;
  kind: WorkspaceKind;
  /** Manifest key used for render-time visibility checks (§9.2). */
  permissionKey: string;
}

export const WORKSPACE_CATALOG: WorkspaceNavItem[] = [
  {
    id: 'home',
    label: 'Home',
    route: '/home',
    icon: 'Home',
    kind: 'platform',
    permissionKey: 'home',
  },
  {
    id: 'knowledge_ontology',
    label: 'Knowledge & Ontology',
    route: '/knowledge',
    icon: 'Network',
    kind: 'platform',
    permissionKey: 'knowledge-ontology',
  },
  {
    id: 'agent_ops',
    label: 'Agent Ops',
    route: '/agent-ops',
    icon: 'Workflow',
    kind: 'platform',
    permissionKey: 'agent-ops',
  },
  {
    id: 'solution_studio',
    label: 'Studio',
    route: '/studio',
    icon: 'Wrench',
    kind: 'platform',
    permissionKey: 'solution-studio',
  },
  {
    id: 'administration',
    label: 'Admin',
    route: '/admin',
    icon: 'Settings',
    kind: 'platform',
    permissionKey: 'administration',
  },
  {
    id: 'data_exploration',
    label: 'Data',
    route: '/data',
    icon: 'Search',
    kind: 'platform',
    permissionKey: 'data-exploration',
  },
  {
    id: 'sre_monitoring',
    label: 'SRE',
    route: '/sre',
    icon: 'Activity',
    kind: 'platform',
    permissionKey: 'sre-monitoring',
  },
  {
    id: 'operational',
    label: 'Operational',
    route: '/operational',
    icon: 'LayoutGrid',
    kind: 'operational',
    permissionKey: 'operational',
  },
];

export function workspaceByRoute(pathname: string): WorkspaceNavItem | undefined {
  return WORKSPACE_CATALOG.find(w => pathname === w.route || pathname.startsWith(`${w.route}/`));
}
